module.exports = __webpack_public_path__ + "img/logo.9d3acee0.png";